<template>
  <v-container id="master-kategori" fluid tag="section" class="cyber-page">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="#018C74"
          icon="mdi-database-cog-outline"
          class="glass-card"
        >
          <template v-slot:heading>
            <div class="display-2 font-weight-black cyber-title">MASTER KATEGORI</div>
            <div class="subtitle-1 secondary-text">
              <v-icon x-small color="#CFA22D">mdi-matrix</v-icon>
              Manajemen klasifikasi kategori & status aktif
            </div>
          </template>

          <v-card-text class="mt-4">
            <v-row class="mb-6 align-center">
              <v-col cols="12" md="6">
                <v-btn class="cyber-btn-add" @click="openDialog()">
                  <v-icon left>mdi-plus-box-multiple-outline</v-icon>
                  INPUT KATEGORI BARU
                </v-btn>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify-scan"
                  label="Cari Data..."
                  single-line
                  hide-details
                  rounded
                  color="#CFA22D"
                  class="cyber-search"
                />
              </v-col>
            </v-row>

            <v-data-table
              :headers="headers"
              :items="categories"
              :search="search"
              :loading="loading"
              class="transparent-table"
            >
              <template v-slot:item.icon_kategori="{ item }">
                <div class="icon-scan-box">
                  <v-img
                    :src="renderImage(item.icon_kategori)"
                    aspect-ratio="1"
                    width="45"
                    height="45"
                    class="rounded-lg cyber-icon-neon"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-icon color="#018C74">mdi-loading mdi-spin</v-icon>
                      </v-row>
                    </template>
                  </v-img>
                </div>
              </template>

              <template v-slot:item.nama_kategori="{ item }">
                <span class="text-uppercase font-weight-bold white--text cyber-item-text">
                  {{ item.nama_kategori }}
                </span>
              </template>

              <template v-slot:item.is_active="{ item }">
                <v-chip
                  small
                  :color="item.is_active == 1 ? '#018C74' : '#CFA22D'"
                  class="font-weight-black"
                  label
                  outlined
                >
                  <v-icon x-small left>{{
                    item.is_active == 1 ? "mdi-check-circle" : "mdi-power-off"
                  }}</v-icon>
                  {{ item.is_active == 1 ? "AKTIF" : "NON-AKTIF" }}
                </v-chip>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn icon class="mr-2 action-glow edit-btn" @click="openDialog(item)">
                  <v-icon small color="#018C74">mdi-pencil-box-multiple-outline</v-icon>
                </v-btn>

                <v-btn icon class="action-glow delete-btn" @click="deleteItem(item)">
                  <v-icon small color="#ff5252">mdi-delete-variant</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialog"
      max-width="500px"
      persistent
      overlay-color="#001a16"
      overlay-opacity="0.9"
    >
      <v-card class="cyber-dialog">
        <div class="dialog-neon-line"></div>
        <v-card-title class="dialog-header pa-5">
          <v-icon left color="#CFA22D">mdi-shield-edit-outline</v-icon>
          <span class="font-weight-black white--text">{{ formTitle }}</span>
          <v-spacer />
          <v-btn icon @click="close" color="#6b7b78" small
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>

        <v-card-text class="pt-8 px-6">
          <v-text-field
            v-model="editedItem.nama_kategori"
            label="NAMA KATEGORI"
            outlined
            color="#018C74"
            class="cyber-input"
            prepend-inner-icon="mdi-tag-text-outline"
          />

          <v-switch
            v-model="editedItem.is_active"
            :label="`STATUS: ${editedItem.is_active == 1 ? 'AKTIF' : 'NON-AKTIF'}`"
            :true-value="1"
            :false-value="0"
            color="#018C74"
            inset
            class="cyber-input mb-4"
          ></v-switch>

          <v-file-input
            v-model="imageFile"
            label="UNGGAH ICON"
            accept="image/*"
            outlined
            color="#018C74"
            prepend-icon=""
            prepend-inner-icon="mdi-image-filter-center-focus-strong-outline"
            @change="previewImage"
            class="cyber-input"
          />

          <v-expand-transition>
            <div v-if="imageUrl" class="d-flex flex-column align-center my-6">
              <div class="preview-hex-frame">
                <v-img
                  :src="imageUrl"
                  aspect-ratio="1"
                  cover
                  class="rounded-lg shadow-glow"
                />
                <div class="scan-overlay"></div>
              </div>
              <div class="caption mt-2 secondary-text font-weight-bold">
                VISUAL PREVIEW
              </div>
            </div>
          </v-expand-transition>
        </v-card-text>

        <v-card-actions class="pa-6 pt-0">
          <v-btn
            text
            @click="close"
            color="rgba(255,255,255,0.5)"
            class="font-weight-bold"
            >BATAL</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn class="cyber-btn-save" :loading="loading" @click="save"> SIMPAN </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
const BASE_URL = "https://berkah.bondowosokab.go.id:5500";
const API_URL = `${BASE_URL}/master/category`;

export default {
  data: () => ({
    search: "",
    loading: false,
    dialog: false,
    categories: [],
    imageFile: null,
    imageUrl: null,
    headers: [
      { text: "ICON VISUAL", value: "icon_kategori", width: "120px", sortable: false },
      { text: "NAMA KATEGORI", value: "nama_kategori" },
      { text: "STATUS", value: "is_active", width: "130px", align: "center" },
      { text: "AKSI", value: "actions", sortable: false, align: "end" },
    ],
    editedIndex: -1,
    editedItem: { id: null, nama_kategori: "", icon_kategori: "", is_active: 1 },
    defaultItem: { id: null, nama_kategori: "", icon_kategori: "", is_active: 1 },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "REGISTRASI DATA BARU" : "MODIFIKASI ENTITAS";
    },
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    renderImage(filename) {
      if (!filename) return null;
      return `${BASE_URL}/uploads/${filename}`;
    },
    async fetchData() {
      this.loading = true;
      try {
        const res = await axios.get(API_URL, {
          headers: {
            "Bondowoso-Berkah":
              "7039338ec2fa8ac649760ddd8404b711b207479377c846d41d5d24b7b21beb97",
          },
        });

        const dataRes = res.data.response ? res.data.response.data : res.data.data || [];
        this.categories = dataRes;
      } catch (e) {
        console.error("Gagal load data:", e);
      } finally {
        this.loading = false;
      }
    },
    previewImage() {
      if (this.imageFile) {
        this.imageUrl = URL.createObjectURL(this.imageFile);
      } else {
        this.imageUrl =
          this.editedIndex > -1 ? this.renderImage(this.editedItem.icon_kategori) : null;
      }
    },
    openDialog(item) {
      this.editedIndex = item ? this.categories.indexOf(item) : -1;
      this.editedItem = item
        ? Object.assign({}, item)
        : Object.assign({}, this.defaultItem);
      this.imageUrl = item ? this.renderImage(item.icon_kategori) : null;
      this.imageFile = null;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.imageFile = null;
        this.imageUrl = null;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async save() {
      if (!this.editedItem.nama_kategori)
        return alert("Sistem: Nama kategori wajib diisi.");
      this.loading = true;
      try {
        const formData = new FormData();
        formData.append("nama_kategori", this.editedItem.nama_kategori);
        formData.append("is_active", this.editedItem.is_active);

        if (this.imageFile) formData.append("icon_kategori", this.imageFile);

        const config = {
          headers: {
            "Content-Type": "multipart/form-data",
            "Bondowoso-Berkah":
              "7039338ec2fa8ac649760ddd8404b711b207479377c846d41d5d24b7b21beb97",
          },
        };

        if (this.editedIndex > -1) {
          await axios.put(`${API_URL}/${this.editedItem.id}`, formData, config);
        } else {
          await axios.post(API_URL, formData, config);
        }
        this.fetchData();
        this.close();
      } catch (e) {
        alert("Sistem: Gagal melakukan sinkronisasi data.");
      } finally {
        this.loading = false;
      }
    },
    async deleteItem(item) {
      if (confirm(`PURGE DATA: ${item.nama_kategori}? Tindakan ini bersifat permanen.`)) {
        try {
          await axios.delete(`${API_URL}/${item.id}`, {
            headers: {
              "Bondowoso-Berkah":
                "7039338ec2fa8ac649760ddd8404b711b207479377c846d41d5d24b7b21beb97",
            },
          });
          this.fetchData();
        } catch (e) {
          alert("Sistem: Penghapusan gagal.");
        }
      }
    },
  },
};
</script>

<style scoped>
.cyber-page {
  background: transparent;
}
.cyber-title {
  letter-spacing: 5px !important;
  text-shadow: 0 0 12px rgba(1, 140, 116, 0.5);
  color: white !important;
}
.secondary-text {
  color: #cfa22d !important;
  font-size: 0.85rem;
  letter-spacing: 1.5px;
}
.glass-card {
  background: rgba(0, 20, 18, 0.9) !important;
  backdrop-filter: blur(15px);
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}
.cyber-btn-add {
  background: linear-gradient(135deg, #018c74 0%, #001a16 100%) !important;
  color: white !important;
  font-weight: 900;
  border: 1px solid #cfa22d !important;
}
.cyber-btn-save {
  background: #cfa22d !important;
  color: #001a16 !important;
  font-weight: 900 !important;
}
.transparent-table {
  background: transparent !important;
}
.transparent-table >>> th {
  background: rgba(1, 140, 116, 0.1) !important;
  color: #cfa22d !important;
  font-weight: 800;
  border-bottom: 2px solid #018c74 !important;
}
.icon-scan-box {
  padding: 6px;
  background: rgba(1, 140, 116, 0.05);
  border: 1px solid rgba(1, 140, 116, 0.3);
  border-radius: 12px;
  display: inline-block;
}
.cyber-dialog {
  background: rgba(0, 18, 16, 0.98) !important;
  border: 1px solid #018c74 !important;
}
.dialog-neon-line {
  height: 3px;
  background: linear-gradient(90deg, #018c74, #cfa22d, #018c74);
}
.preview-hex-frame {
  position: relative;
  padding: 10px;
  border: 2px solid #cfa22d;
  border-radius: 20px;
  width: 140px;
  overflow: hidden;
  margin: 0 auto;
}

.cyber-page,
.cyber-container,
.cyber-portal {
  background: transparent !important;
}

.cyber-title,
.cyber-text,
.cyber-id,
.cyber-desc,
.cyber-item-text {
  color: #1c2b28 !important;
  text-shadow: none !important;
}

.secondary-text {
  color: #018c74 !important;
  text-shadow: none !important;
}

.glass-card,
.cyber-card,
.cyber-dialog,
.cyber-dialog-card,
.cyber-modal,
.cyber-map-container,
.cyber-mapping-container,
.cyber-news-container,
.cyber-moments,
.cyber-carousel,
.cyber-agenda,
.cyber-sosmed-header,
.cyber-map-box,
.cyber-map {
  background: #ffffff !important;
  border: 1px solid #eef1f0 !important;
  backdrop-filter: none !important;
  color: #1c2b28 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.dialog-header,
.dialog-header-gradient {
  background: #f4f7f6 !important;
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.dialog-header .white--text,
.dialog-header-gradient .white--text,
.cyber-dialog .white--text,
.cyber-dialog-card .white--text {
  color: #1c2b28 !important;
}

.dialog-neon-line,
.neon-line {
  background: linear-gradient(90deg, #018c74, #cfa22d, #018c74) !important;
}

.transparent-table,
.cyber-table,
.transparent-tabs {
  background: #ffffff !important;
  color: #1c2b28 !important;
}

.transparent-table >>> th,
.cyber-table >>> th {
  background: #f4f7f6 !important;
  color: #018c74 !important;
  font-weight: 800;
  border-bottom: 2px solid #018c74 !important;
}

.transparent-table >>> td,
.cyber-table >>> td {
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.transparent-table >>> .v-data-table__empty-wrapper,
.cyber-table >>> .v-data-table__empty-wrapper {
  color: #9aa6a3 !important;
}

.cyber-input,
.cyber-field,
.cyber-search,
.cyber-search-field,
.cyber-search-bar,
.cyber-input-mini,
.cyber-input-dense,
.cyber-input-highlight,
.cyber-input-coord,
.cyber-coord-field,
.cyber-select-dense,
.cyber-file-input,
.cyber-datepicker {
  color: #1c2b28 !important;
}

.cyber-input >>> .v-input__control,
.cyber-field >>> .v-input__control,
.cyber-search >>> .v-input__control,
.cyber-search-field >>> .v-input__control,
.cyber-search-bar >>> .v-input__control,
.cyber-input-mini >>> .v-input__control,
.cyber-input-dense >>> .v-input__control,
.cyber-input-highlight >>> .v-input__control,
.cyber-input-coord >>> .v-input__control,
.cyber-coord-field >>> .v-input__control,
.cyber-select-dense >>> .v-input__control,
.cyber-file-input >>> .v-input__control,
.cyber-datepicker >>> .v-input__control {
  background: #ffffff !important;
  border-radius: 10px;
}

.cyber-input >>> input,
.cyber-field >>> input,
.cyber-search >>> input,
.cyber-search-field >>> input,
.cyber-search-bar >>> input,
.cyber-input-mini >>> input,
.cyber-input-dense >>> input,
.cyber-input-coord >>> input,
.cyber-coord-field >>> input,
.cyber-datepicker >>> input,
.cyber-input >>> .v-label,
.cyber-field >>> .v-label,
.cyber-search >>> .v-label,
.cyber-search-field >>> .v-label,
.cyber-search-bar >>> .v-label,
.cyber-select-dense >>> .v-label,
.cyber-datepicker >>> .v-label {
  color: #1c2b28 !important;
}

.cyber-btn-add,
.cyber-add-btn,
.cyber-add-sosmed-btn {
  background: linear-gradient(135deg, #018c74 0%, #02b395 100%) !important;
  color: #ffffff !important;
  font-weight: 700;
  border: none !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.cyber-btn-save,
.cyber-save-btn {
  background: #018c74 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.icon-scan-box,
.icon-scan-frame,
.preview-container,
.preview-hex-frame,
.preview-mini-frame,
.preview-scanner {
  background: #f4f7f6 !important;
  border: 1px solid #eef1f0 !important;
}

.preview-tag {
  background: #eaf6f3 !important;
  color: #018c74 !important;
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}

.scan-overlay {
  display: none !important;
}

.shadow-glow,
.shadow-glow-gold,
.shadow-glow-teal {
  box-shadow: 0 6px 16px rgba(1, 140, 116, 0.15) !important;
}

.action-glow.edit-btn,
.action-glow.delete-btn {
  background: transparent !important;
}


.v-data-table >>> .white--text {
  color: #1c2b28 !important;
}
.plain-description {
  color: #4a5a57 !important;
}

</style>
